import { gql } from '@apollo/client';

export default gql`
  query fetchPageData($name: String) {
    pageData(name: $name) {
      ancestor {
        planNodeId
        title
      }
      cache {
        ... on Homepage {
          headerPosition
          navTextColor
          banner {
            image
            position
            text
            backgroundColor
            enable
            withImage
            opacity
            textDecoration
            textDecorationColor
            imageBlendMode
          }
          newsFeed {
            title
            enabled
            feed
            position
            backgroundColor
          }
          columns
          introContent {
            text
            backgroundColor
            type
          }
          subContent {
            text
            backgroundColor
          }
          mainContentBackgroundColor
          showProgress
          children {
            enable
            thumbnail {
              image
              position
            }
            planNodeId
            title
            description
            onTrack
            upcoming
            statusPending
            minorDisruption
            majorDisruption
            completed
            discontinued
            progress
            tags
          }
          overlapCardTitle
          showCardDescription
        }
        ... on PlanNodePage {
          planNodeId
          parentPlanNodeId
          title
          description
          latestUpdate
          showLatestUpdate
          additionalText
          additionalBottomText
          additionalMiddleText
          additionalUpperMiddleText
          progress
          onTrack
          upcoming
          statusPending
          minorDisruption
          majorDisruption
          completed
          discontinued
          numberWithLabel
          startDate
          endDate
          budget
          expenditure
          phase
          checklist
          tags
          customFieldRecords {
            checkBoxChecked
            content
            customFieldId
            id
            picklistItems
          }
          children {
            cloneSourcePlanNodeId
            completed
            description
            discontinued
            enable
            budget
            expenditure
            phase
            majorDisruption
            minorDisruption
            onTrack
            planNodeId
            progress
            rollup
            statusPending
            tags
            title
            upcoming
            thumbnail {
              image
              position
            }
          }
          measures {
            title
            measureId
            embed
            comment
            enable
            advancedMetric
            advancedMetricType
            advancedMetricTargetUnit
            advancedMetricChartType
            singleTargetMilestoneDate
            singleTargetTargetAmount
            singleTargetAggregationFunction
            handsontable
            highChartSetting
            performanceGraphUrl
            metricType
            summaryDetails
            label
            viewType
            visualTitle
            visualDescription
            measureResults {
              dataPointX
              dataPointYTarget
              dataPointYValue
            }
            tags
          }
        }
        ... on MeasurePage {
          title
          description
          showComment
          embed
          comment
          additionalText
          additionalBottomText
          additionalMiddleText
          additionalUpperMiddleText
          measureId
          advancedMetric
          advancedMetricType
          advancedMetricTargetUnit
          advancedMetricChartType
          singleTargetMilestoneDate
          singleTargetTargetAmount
          singleTargetAggregationFunction
          handsontable
          highChartSetting
          performanceGraphUrl
          metricType
          summaryDetails
          label
          viewType
          visualTitle
          visualDescription
          measureResults {
            dataPointX
            dataPointYTarget
            dataPointYValue
          }
          tags
        }
      }
    }
  }
`; 